import { API } from '../../utils';
import { IParams } from '../types';
import { GW_SERVICES_PREFIXES } from '../../constants';

const { C300, GIS } = GW_SERVICES_PREFIXES;

/** Проверка на доступ к ГИС */
export const CheckGISAccess = () =>
  API.get(`/${GIS}/gis/appeals/has_access/`);

export const GetGISGUIDS = (params: IParams) =>
  API.get(`/${C300}/gis/guids/`, undefined, params);

export const PostGISGUIDS = (params: IParams) =>
  API.gatewayPost(`/${C300}/gis/guids/`, params);

/* Список операций ГИС */
export const GetGISRecords = (params: IParams) =>
  API.get('/gis/all_records/', undefined, params);

/* Обновление информации записи операции ГИС */
export const UpdateGISRecord = (id: string, params: IParams) =>
  API.gatewayPatch('/gis/all_records/', id, params);

/* Список ошибок по записи в ГИС */
export const GetGISRecordErrors = (id: string) =>
  API.get('/gis/error_guids/', id);

/* Детализация object_id ошибки ГИС */
export const GetErrorDetails = (id: string) =>
  API.get(`/gis/guids/${id}/object_url/`);

/** Синхронизация обращений с ГИС */
export const SyncGISAppeals = () =>
  API.gatewayPost(`/${GIS}/gis/appeals/import/`);

/** Проверить синхронизацию обращений с ГИС */
export const CheckGISAppealsSync = () =>
  API.gatewayPost(`/${GIS}/gis/appeals/check/`);
